import*as React from'react';var ReportDetailPaneCardItem=function ReportDetailPaneCardItem(props){return<>
      <div className="card-body py-2">
        <h5 className="card-title text-primary mb-2"style={{fontSize:'14px'}}>{props.title}</h5>
        <div className="px-4"style={{fontSize:'14px'}}>
          {props.children}
        </div>
      </div>
    </>;};export default ReportDetailPaneCardItem;